$(function () {
  var braSizeConverter = {
    init: function (countryFromSelector, countryToSelector, sizeFromSelector, sizeToSelector, nextSelector, prevSelector) {
      this.countryFromSelector = countryFromSelector;
      this.countryToSelector = countryToSelector;
      this.sizeFromSelector = sizeFromSelector;
      this.sizeToSelector = sizeToSelector;
      this.nextSelector = nextSelector;
      this.prevSelector = prevSelector;
      this.backSizeMapping = this.getBackSizeMapping();
      this.cupSizeMapping = this.getCupSizeMapping();
      this.sizes = this.generateSizes();
      this.initializeFields();
      this.initializeHandlers();
    },
    getCountries: function () {
      return ['UK', 'US', 'FR', 'EUR', 'AUS'];
    },
    getBackSizeMapping: function () {
      return {
        UK: [28, 30, 32, 34, 36, 38, 40],
        US: [28, 30, 32, 34, 36, 38, 40],
        FR: [75, 80, 85, 90, 95, 100],
        EUR: [60, 65, 70, 75, 80, 85, 90],
        AUS: [6, 8, 10, 12, 14, 16, 18],
      };
    },
    getCupSizeMapping: function () {
      return {
        UK: ['AA', 'A', 'B', 'C', 'D', 'DD', 'DD', 'E', 'E', 'F', 'G'],
        US: ['AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'DDD', 'F', 'G', 'I'],
        FR: ['AA', 'A', 'B', 'C', 'D', 'E', 'E', 'F', 'F', 'G', 'J'],
        EUR: ['AA', 'A', 'B', 'C', 'D', 'E', 'E', 'F', 'F', 'G', 'J'],
        AUS: ['AA', 'A', 'B', 'C', 'D', 'DD', 'DD', 'E', 'E', 'F', 'FF'],
      };
    },
    generateSizes: function () {
      var cupSizeMapping = this.cupSizeMapping;
      var allSizes = {};
      $.each(this.backSizeMapping, function (k, v) {
        backSizes = v;
        cupSizes = cupSizeMapping[k];
        var sizes = [];
        $.each(backSizes, function (k, v) {
          $.each(cupSizes, function (k2, v2) {
            sizes.push(v + v2);
          });
        });
        allSizes[k] = sizes.sort();
      });
      return allSizes;
    },
    getSizesForCountry: function (country) {
      var sizes = this.sizes[country];
      if (typeof sizes == 'undefined') {
        return [];
      }
      return this.sizes[country];
    },
    initializeFields: function () {
      var countries = this.getCountries();
      var countryFromSelector = this.countryFromSelector;
      var countryToSelector = this.countryToSelector;
      var sizeFromSelector = this.sizeFromSelector;
      var sizeToSelector = this.sizeToSelector;
      $.each(countries, function (k, v) {
        $(countryFromSelector).append('<option value="' + v + '">' + v + '</option>');
        $(countryToSelector).append('<option value="' + v + '">' + v + '</option>');
      });
      var fromCountry = $('#converter-from-country-select').val();
      var fromSizes = this.getSizesForCountry(fromCountry);
      $.each(fromSizes, function (k, v) {
        $(sizeFromSelector).append('<option value="' + v + '">' + v + '</option>');
      });
    },
    initializeHandlers: function () {
      $(this.prevSelector).on('click', function (ev) {
        ev.preventDefault();
        var countryFrom = $(braSizeConverter.countryToSelector).val();
        var countryTo = $(braSizeConverter.countryFromSelector).val();
        var size = $(braSizeConverter.sizeToSelector).val();
        var convertedSize = braSizeConverter.getConversion(countryFrom, countryTo, size);
        if (convertedSize) {
          $(braSizeConverter.sizeFromSelector).val(convertedSize);
        } else {
          alert('An error occurred when trying to convert your size.');
        }
      });
      $(this.nextSelector).on('click', function (ev) {
        ev.preventDefault();
        var countryFrom = $(braSizeConverter.countryFromSelector).val();
        var countryTo = $(braSizeConverter.countryToSelector).val();
        var size = $(braSizeConverter.sizeFromSelector).val();
        var convertedSize = braSizeConverter.getConversion(countryFrom, countryTo, size);
        if (convertedSize) {
          $(braSizeConverter.sizeToSelector).val(convertedSize);
        } else {
          alert('An error occurred when trying to convert your size');
        }
      });
      $(this.countryFromSelector).on('change', function (ev) {
        var fromCountry = $('#converter-from-country-select').val();
        var fromSizes = braSizeConverter.getSizesForCountry(fromCountry);
        $(braSizeConverter.sizeFromSelector).find('option').remove();
        $.each(fromSizes, function (k, v) {
          $(braSizeConverter.sizeFromSelector).append('<option value="' + v + '">' + v + '</option>');
        });
      });
    },
    getConversion: function (countryFrom, countryTo, size) {
      if (typeof this.backSizeMapping != 'undefined' && typeof this.cupSizeMapping != 'undefined') {
        var regexp = new RegExp('([0-9]+)([A-Z]+)');
        var result = size.match(regexp);
        var backSize = parseInt(result[1]);
        var cupSize = result[2];
        if (
          typeof this.backSizeMapping[countryFrom] != 'undefined' &&
          typeof this.cupSizeMapping[countryFrom] != 'undefined' &&
          typeof this.backSizeMapping[countryTo] != 'undefined' &&
          typeof this.cupSizeMapping[countryTo] != 'undefined'
        ) {
          var backSizeIndex = this.backSizeMapping[countryFrom].indexOf(backSize);
          var cupSizeIndex = this.cupSizeMapping[countryFrom].indexOf(cupSize);
          var convertedBackSize = this.backSizeMapping[countryTo][backSizeIndex];
          var convertedCupSize = this.cupSizeMapping[countryTo][cupSizeIndex];
          if (typeof convertedBackSize != 'undefined' && typeof convertedCupSize != 'undefined') {
            return convertedBackSize + convertedCupSize;
          }
        }
        return false;
      }
    },
  };
  braSizeConverter.init(
    '#converter-from-country-select',
    '#converter-to-country-select',
    '#converter-from-size-select',
    '#converter-to-size-textfield',
    '.country-calcbox a.next',
    '.country-calcbox a.prev'
  );
});
